import {
    payForOptions,
    strategyOptions,
} from '../../ContentPromotionBudget/parts/ContentPromotionBudgetStrategy/constants';
import { GetStrategyTextProps } from '../types';

export const getStrategyText = ({ strategyType, payFor }: GetStrategyTextProps) => {
    const strategyText = strategyOptions.find((strategy) => strategy.value === strategyType);
    const payForText = payForOptions.find((option) => option.value === payFor);

    if (strategyText && payForText) {
        return `${strategyText.label}, оплата ${payForText.label.toLowerCase()}`;
    }

    if (strategyText) {
        return strategyText.label;
    }

    if (payForText) {
        return `Оплата ${payForText.label.toLowerCase()}`;
    }

    return '';
};
